import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useState } from 'react';
import { submitFeedback } from "../../../api/FeedbackAPI";
import { useUser } from "../../../AuthContext";
import { toast } from 'react-toastify';
/**
 * This is the 'Get Premium' card on the dashboard.
 */
export default function CardAlert() {
  const { user, accessToken } = useUser();
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async () => {
    try {
      setIsSubmitted(true);
      await submitFeedback(`${user.email} want to join premium waitlist`, accessToken);
    } catch (error) {
      toast.error('Failed to join waitlist. Please try again.');
    }
  }

  return (
    <Card variant="outlined" sx={{ m: 1.5, p: 1.5 }}>
      <CardContent>
        <AutoAwesomeRoundedIcon fontSize="small" />
        <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
          Premium is coming soon - join the waitlist to be the first to know!
        </Typography>
        <Button 
          variant={isSubmitted ? "outlined" : "contained"}
          size="small" 
          fullWidth 
          onClick={handleSubmit}
          disabled={isSubmitted}
          startIcon={isSubmitted ? <CheckCircleIcon /> : null}
          sx={{
            ...(isSubmitted && {
              color: 'success.main',
              borderColor: 'success.main',
              '&:hover': {
                borderColor: 'success.main',
              }
            })
          }}
        >
          {isSubmitted ? 'Waitlist Joined' : 'Join Waitlist'}
        </Button>
      </CardContent>
    </Card>
  );
}
